import request from '@/utils/request'

export function getCommentList(data) {
  return request({
    url: '/api/albumqa/getCourseQaList',
    method: 'get',
    params: data
  })
}

export function getClassList(data) {
  return request({
    url: '/api/albumqa/getClassQaList',
    method: 'get',
    params: data
  })
}

export function uploadPicture(data) {
  return request({
    url: '/api/albumqa/uploadFile',
    method: 'post',
    data
  })
}

export function uploadComments(data) {
  return request({
    url: '/api/albumqa/addCourseQa',
    method: 'post',
    data
  })
}

export function uploadPlayComments(data) {
  return request({
    url: '/api/albumqa/addClassQa',
    method: 'post',
    data
  })
}

export function uploadReply(data) {
  return request({
    url: '/api/albumqa/addCourseReplyQa',
    method: 'post',
    data
  })
}

export function getQaChildList(data) {
  return request({
    url: '/api/albumqa/getQaChildList',
    method: 'get',
    params: data
  })
}


// 意见反馈
export const feedback = (data) => request.post(`/api/index/feedback`, data)


// WEBPACK FOOTER //
// ./src/api/comment.js